import cisFertigationDataConfig from '@/api/config/cisFertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { IFormCisFertigation, IFormCisFertigationMode } from '@/types/cisFertigation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function update(payload: IFormCisFertigationMode): Promise<void> {
  await cisFertigationDataConfig.editFertigationMode(payload)
}

function useUpdateCisFertigationMode() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeModal } = useConfigUI()

  return useMutation((payload: IFormCisFertigationMode) => update(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.cisFertigationMode])
      toast.success(t('updateFertigationModeSuccess'))
      closeModal()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('updateFertigationModeError'))
    },
  })
}

export default useUpdateCisFertigationMode
